// extracted by mini-css-extract-plugin
export default {"closeIcon":"EventPopup_closeIcon__E3O8Z","actionBtn":"EventPopup_actionBtn__ipFFT"};